import { SnapchatEventNames } from '../../entities';
import { SnapchatService } from '../../interfaces/SnapchatService';

export class SnapchatServiceDecorator implements SnapchatService {
  constructor(protected readonly snapchatService: SnapchatService) {}

  isSnaptrAvailable() {
    return this.snapchatService.isSnaptrAvailable();
  }

  isSnaptrRequired() {
    return this.snapchatService.isSnaptrRequired();
  }

  track(eventName: SnapchatEventNames, params?: Record<string, unknown>) {
    return this.snapchatService.track(eventName, params);
  }

  updateUserData(userData: { user_email: string }) {
    return this.snapchatService.updateUserData(userData);
  }
}
